"use client";
import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();
  const handleNavigation = (path) => navigate(path);

  return (
    <motion.footer
      className="w-full shadow-[0px_-4px_20px_rgba(0,0,0,0.25)]"
      initial={{ opacity: 0, y: 100 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      role="contentinfo"
    >
      {/* Top Section */}
      <div className="flex flex-col items-center px-4 md:px-16 py-12 w-full bg-orange-100 text-neutral-800">
        <motion.div
          className="flex flex-wrap gap-10 justify-between items-start w-full max-w-7xl mx-auto"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {/* Logo & About */}
          <div className="w-full md:w-1/4 px-4">
            <motion.div
              className="flex flex-col lg:flex-row gap-2.5 items-center text-xl font-semibold cursor-pointer"
              whileHover={{ scale: 1.05 }}
              onClick={() => handleNavigation("/home")}
            >
              <img src ="https://api.builder.io/api/v1/image/assets/TEMP/365ffa53b9e278e408248b662141c7b81b7ce061?width=410" alt = "img" />
              <h2 className="whitespace-nowrap text-center lg:text-left">Iyna Cakes & Desserts</h2>
            </motion.div>
            <p className="text-base leading-6 mt-2">
              We are devoted to making life a little sweeter, one delectable
              treat at a time. Thank you for choosing us as your go-to bakery,
              and we look forward to serving you.
            </p>
          </div>

          {/* Quick Links & Contact */}
          <div className="flex flex-row gap-7 w-full md:w-1/2">
            {/* Quick Links */}
            <div className="flex flex-col w-1/2">
              <h3 className="text-xl font-semibold">Quick Links</h3>
              <ul className="mt-2 text-base leading-7">
                {["/home", "/menu", "/about"].map((path, idx) => (
                  <li key={idx}>
                    <button
                      onClick={() => handleNavigation(path)}
                      className="hover:text-red-500 transition-colors duration-200 text-left"
                    >
                      {path === "/home"
                        ? "Home"
                        : path === "/menu"
                        ? "Menu"
                        : "About us"}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="flex flex-col w-1/2">
              <h3 className="text-xl font-semibold">Contact Us</h3>
              <address className="mt-2 text-base not-italic space-y-1.5">
                <a
                  href="tel:418-655-1666"
                  className="hover:text-red-500 transition-colors duration-200 flex items-center gap-2"
                >
                  <FaPhone className="text-sm" /> 418-655-1666
                </a>
                <a
                  href="mailto:iynacakes@info.com"
                  className="hover:text-red-500 transition-colors duration-200 flex items-center gap-2"
                >
                  <FaEnvelope className="text-sm" /> iynacakes@info.com
                </a>
                <span className="flex items-center gap-2">
                  <FaMapMarkerAlt className="text-sm" /> 1632 University Ave W, Windsor, Ontario,
                  Canada N9B 1C2
                </span>
              </address>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Bottom Bar */}
      <motion.div
        className="flex flex-wrap justify-between items-center py-7 px-4 md:px-16 text-base text-white bg-neutral-700 w-full"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 1 }}
        viewport={{ once: true }}
      >
        <div>
          © 2025 IYNA CAKES & DESSERTS. Designed and Developed by{" "}
          <a
            href="https://algorithmicaconsulting.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-orange-200 hover:underline hover:text-orange-300 transition-colors duration-200"
          >
            Algorithmica Consultancy Services Pvt Ltd.
          </a>
        </div>
        <button
          className="hover:text-orange-200 transition-colors duration-200 sm:text-center"
          onClick={() => handleNavigation("/PrivacyPolicy")}
        >
          Privacy Policy
        </button>
      </motion.div>

    </motion.footer>
  );
};

export default Footer;